/** Hooks e utilidades das telas de vendas e contas a receber. */
import type { SalesOrder, SalesStatus } from "@cafegestor/shared";
import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api";

export const ORDER_KEY = ["vendas", "pedidos"];

export const SALES_TONE: Record<SalesStatus, "neutral" | "ok" | "warn" | "error"> = {
  rascunho: "neutral",
  aprovado: "warn",
  confirmado: "ok",
  cancelado: "neutral",
  estornado: "error",
};

export function useOrder(id: string) {
  return useQuery({
    queryKey: [...ORDER_KEY, "detalhe", id],
    queryFn: () => apiFetch<SalesOrder>(`/vendas/pedidos/${id}`),
  });
}

/** Vendedor restrito (só os próprios pedidos) ou não. */
export function useSalesContext() {
  return useQuery({
    queryKey: [...ORDER_KEY, "contexto"],
    queryFn: () => apiFetch<{ restrictedSalespersonId: string | null }>("/vendas/contexto"),
    staleTime: 60_000,
  });
}

// preço de tabela: desde a A0 no cliente compartilhado (o mesmo do CaféGestor Vendedor)
export { usePriceLookup } from "@cafegestor/client";
